/**
 * Highlights view — Surface/F10 projection stub.
 *
 * Law (SURFACE-F10-INHABITED-SPEC-v0.1): Highlights are an Envoy feature.
 * They presuppose an intelligent campaign running. Until the Envoy feature
 * lands, this view Present/True states that fact — it does not invent data.
 */

import { applyMembrane } from "../lib/api-clients";

interface HighlightsViewProps {
  isOperator: boolean;
  onOpenCampaigns: () => void;
}

export function HighlightsView({ isOperator, onOpenCampaigns }: HighlightsViewProps) {
  const bypass = isOperator;

  return (
    <div className="view">
      <div className="view-header">
        <span className="eyebrow">{applyMembrane("Envoy", bypass)}</span>
        <h1>{applyMembrane("Highlights", bypass)}</h1>
        <p className="view-lede">
          {applyMembrane(
            "Highlights surface from intelligent outreach campaigns — moments of impact your Spec can inhabit. They are not a separate product.",
            bypass
          )}
        </p>
      </div>

      <div className="card" style={{ maxWidth: 560 }}>
        <div className="card-title">{applyMembrane("Campaign substrate ready", bypass)}</div>
        <p className="card-meta" style={{ lineHeight: 1.55, marginTop: 8 }}>
          {applyMembrane(
            isOperator
              ? "Envoy campaigns/sequences exist (envoy.getrida.work). Highlights feature = declared in Tenant Build IR — Greenfield not claimed."
              : "Your outreach campaigns are the source. Highlights will appear here when campaign intelligence has moments worth keeping in your Spec.",
            bypass
          )}
        </p>
        <button className="btn primary" style={{ marginTop: 16 }} onClick={onOpenCampaigns}>
          {applyMembrane("Open campaigns", bypass)}
        </button>
      </div>
    </div>
  );
}
